'use client';

import { useEffect } from 'react';
import { IPageMetadata } from '../../interfaces/nextjs';
import { useAnalytics } from '../../contexts/AnalyticsContext/AnalyticsContext';

type IProps = {
  blockDatadogRum?: boolean;
  pageProps: IPageMetadata;
};

export function AnalyticsUpdater({ blockDatadogRum, pageProps }: IProps) {
  const { setCurrentPage, setBlockDatadogRum } = useAnalytics();

  useEffect(() => {
    setCurrentPage({
      ...pageProps,
    });
  }, [pageProps, setCurrentPage]);

  useEffect(() => {
    setBlockDatadogRum(!!blockDatadogRum);
  }, [blockDatadogRum, setBlockDatadogRum]);

  return null;
}
